import { defineStore } from 'pinia'
import { store } from '../index'
import { UserLoginType, UserType } from '@/api/login/types'
import { ElMessageBox } from 'element-plus'
import { useI18n } from '@/hooks/web/useI18n'
import { loginOutApi } from '@/api/login'
import { useTagsViewStore } from './tagsView'
import router from '@/router'
import { Layout, getParentLayout } from '@/utils/routerHelper'
interface UserState {
  userInfo?: UserType
  tokenKey: string
  token: string
  roleRouters:AppRouteRecordRaw[]
  menulist:any
  rememberMe: boolean
  loginInfo?: UserLoginType
}

export const useUserStore = defineStore('user', {
  state: (): UserState => {
    return {
      userInfo: undefined,
      tokenKey: 'Authorization',
      token: '',
      roleRouters: [],
      menulist:undefined,
      // 记住我
      rememberMe: true,
      loginInfo: undefined
    }
  },
  getters: {
    getTokenKey(): string {
      return this.tokenKey
    },
    getToken(): string {
      return this.token
    },
    getUserInfo(): UserType | undefined {
      return this.userInfo
    },
    getRoleRouters(): AppRouteRecordRaw[]  {
      return this.roleRouters
    },
    getMenulist():any{
      return this.menulist
    },
    getRememberMe(): boolean {
      return this.rememberMe
    },
    getLoginInfo(): UserLoginType | undefined {
      return this.loginInfo
    }
  },
  actions: {
    setTokenKey(tokenKey: string) {
      this.tokenKey = tokenKey
    },
    setToken(token: string) {
      this.token = token
    },
    setUserInfo(userInfo?: UserType) {
      this.userInfo = userInfo
    },
    setMenulist(menulist:any){
      this.menulist=menulist
    },
    setRoleRouters(roleRouters: AppRouteRecordRaw[]) {
      var routers=this.filterRoutersByPermission(roleRouters);
      console.log(routers);
      this.roleRouters = routers;
    },
    // setRoleRouters(roleRouters: AppRouteRecordRaw[]) {
    //   var routers=this.filterRoutersByPermission(roleRouters);
    //   this.roleRouters = ([
    //     {
    //       path: '/dashboard',
    //       component: Layout,
    //       name: 'Dashboard', 
    //       meta: {
    //         title: 'router.dashboard', 
    //         icon:'material-symbols:home',
    //         hidden: false, 
    //       },
    //       children: [
    //         {
    //           path: '', 
    //           component: () => import('@/views/Dashboard/Dashboard.vue'),
    //           name: 'DashboardIndex',
    //           meta: {
    //             icon:'material-symbols:home',
    //             title: 'router.dashboard',
    //             noTagsView: false
    //           }
    //         }
    //       ]
    //     }]).concat(routers);
    // },
      /**
   * 递归过滤路由：判断当前路由 + 子路由的权限
   * @param routers 待过滤的路由数组（当前层级）
   * @returns 过滤后的路由数组
   */
   filterRoutersByPermission(routers: AppRouteRecordRaw[]): AppRouteRecordRaw[] {
    // 存储当前层级符合权限的路由
    const result: AppRouteRecordRaw[] = [];

    for (const route of routers) {
      if (!route || !route.component) continue; // 跳过空路由或没有组件的路由
      // 1. 判断当前层级路由的权限（核心扩展点：替换为你的实际权限判断逻辑）  
      // 如果 menulist 未设置，默认允许所有路由
      const hasCurrentPermission = !this.menulist || this.menulist.filter(item => item.menuCode === route.name).length > 0;
      console.log("----------------------");
      console.log(this.menulist);
      console.log(hasCurrentPermission);
      console.log(!this.menulist);
      
      console.log(this.menulist.filter(item => item.menuCode === route.name).length > 0);
      console.log("----------------------");
      if (!hasCurrentPermission) continue; // 无权限则跳过当前路由
      console.log("------------1----------");
      // 2. 处理子路由：递归过滤子路由的权限
      let filteredChildren: AppRouteRecordRaw[] = [];
      console.log("------------2----------");
      if (route.children && route.children.length > 0) {
        // 递归调用，过滤子路由
        filteredChildren = this.filterRoutersByPermission(route.children);
      }
      console.log("------------3----------");
      // 3. 构建新的路由对象（避免修改原数组）
      const newRoute: AppRouteRecordRaw = { ...route };
      // 替换为过滤后的子路由（保持为空数组而不是删除）
      if (filteredChildren.length > 0) {
        newRoute.children = filteredChildren;
      } else if (route.children) {
        newRoute.children = []; // 保持 children 字段存在但为空数组
      }
      // 4. 将符合权限的路由加入结果集
      result.push(newRoute);
    }

    return result;
  },


    logoutConfirm() {
      const { t } = useI18n()
      ElMessageBox.confirm(t('common.loginOutMessage'), t('common.reminder'), {
        confirmButtonText: t('common.ok'),
        cancelButtonText: t('common.cancel'),
        type: 'warning'
      })
        .then(async () => {
          const res = await loginOutApi().catch(() => {})
          if (res) {
            this.reset()
          }
        })
        .catch(() => {})
    },
    async rePasswordConfirm() {
      const res = await loginOutApi().catch(() => {})
      if (res) {
        this.reset()
      }
    },
    reset() {
      const tagsViewStore = useTagsViewStore()
      tagsViewStore.delAllViews()
      this.setToken('')
      this.setUserInfo(undefined)
      this.setRoleRouters([])
      this.setMenulist([])
      router.replace('/login')
    },
    logout() {
      this.reset()
    },
    setRememberMe(rememberMe: boolean) {
      this.rememberMe = rememberMe
    },
    setLoginInfo(loginInfo: UserLoginType | undefined) {
      this.loginInfo = loginInfo
    }
  },
  persist: {
    pick: ['userInfo', 'tokenKey', 'token', 'rememberMe', 'loginInfo', 'menulist']
  }
})

export const useUserStoreWithOut = () => {
  return useUserStore(store)
}
